import { render } from "./The404Page.vue?vue&type=template&id=6a5f14ca&scoped=true"
import script from "./The404Page.vue?vue&type=script&lang=js"
export * from "./The404Page.vue?vue&type=script&lang=js"

import "./The404Page.vue?vue&type=style&index=0&id=6a5f14ca&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5f14ca"]])

export default __exports__